import { Badge } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { useTranslation } from "react-i18next";
import "../../../../i18n/i18n";

const cleanedColors = {
  backgroundColor: colors["colors/system/success/success_ultraLight"],
  textColor: colors["colors/system/success/success_dark"],
};

const uncleanedColors = {
  backgroundColor: colors["colors/system/error/error_ultraLight"],
  textColor: colors["colors/system/error/error_dark"],
};

export const CleaningTag = (props: { isCleaned: boolean }) => {
  const { isCleaned } = props;
  const { t } = useTranslation();
  const { backgroundColor, textColor } = isCleaned
    ? cleanedColors
    : uncleanedColors;

  return (
    <Badge
      text={t(`fleet.vehicleSessions.value.${isCleaned}`)}
      backgroundColor={backgroundColor}
      textColor={textColor}
    />
  );
};
